import {useState, useEffect} from "react";
import "./Login.scss";
import logo from "../../Assets/images/protikares.png";
import Verify from "./Verify";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import LoginPic from '../../Assets/images/loginImg.jpg';

const Login = () => {
  const [content, setContent] = useState("login");
  const [type, setType] = useState("login");
  useEffect(() => {
  }, [content]);

  // const setLoginContent = (enteredState) => {
  //   setContent(enteredState);
  // };

  // const setVerifyContent = (enteredState) => {
  //   setContent(enteredState);
  // };
  let rightContent;
  if (content === "login") {
    rightContent = <LoginForm setContent={setContent} setType={setType}/>;
  } else if (content === "verify") {
    rightContent = (
      <Verify
        setContent={setContent}
        setType={content}
        type={type}
        // state={"verify"}
        // btn={"loginbtn"}
      />
    );
  } else if (content === "register") {
    rightContent = <RegisterForm setContent={setContent} setType={setType}/>;
  }
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-form-container">{rightContent}</div>
        <div className="login-img">
          <img src={LoginPic} alt=""/>
        </div>
        <div className="login-logo login-logo-md">
          <img src={logo} alt=""/>
        </div>
      </div>
    </div>
  );
};

export default Login;
